import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Trans, useTranslation } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
// api
import { createUser } from "../../api/users";
import logo from "../../assets/images/logo.svg";
// lib
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from "../../lib/isEmpty";
import { error } from "jquery";
import {
  setLocalStorageWithExpiration,
  getLocalStorageWithExpiration,
} from "../../lib/localStorage";

const initialFormValue = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  referralCode: "",
  referralCodeDisabled: false,
  isTerms: "",
  otpStatus: false,
  otp: "",
  phoneNo: "",
  phoneCode: "",
  passwordIcon: false,
  confirmPasswordIcon: false,
};
const timerInitialValue = {
  isLoading: false,
  type: "send", // send or resend,
  timer: 120, //sec,
  isDisable: false,
  timerStart: false,
};

const RegisterForm = () => {
  const { refCode } = useParams();
  const { t, i18n } = useTranslation();

  //hooks
  const navigate = useNavigate();
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);

  // state
  const [formValue, setFormValue] = useState(initialFormValue);
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [timerDetail, setTimerDetail] = useState(timerInitialValue);
  const {
    email,
    password,
    confirmPassword,
    referralCode,
    isTerms,
    otpStatus,
    otp,
    phoneNo,
    phoneCode,
    passwordIcon,
    confirmPasswordIcon,
    firstName,
    lastName,
    referralCodeDisabled,
  } = formValue;

  //function
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (name == "firstName" || name == "lastName") {
      if (/[^a-zA-Z ]/.test(value)) return;
    }
    if (name == "phoneNo" || name == "phoneCode") {
      if (/[^0-9]/.test(value)) return;
    }
    setFormValue({
      ...formValue,
      ...{ [name]: name != "isTerms" ? value : checked },
    });
    if (!isEmpty(errors)) {
      setErrors({});
    }
  };

  const handlePhoneNumber = (value, country) => {
    const { dialCode } = country;
    let phoneNo = value;
    let formData = formValue;

    if (!isValidPhoneNumber("+" + value) && value.length > 3) {
      setErrors({ ...errors, ...{ phoneNo: t("PHONE_NUMBER_INVALID") } });
    } else {
      setErrors({ ...errors, ...{ phoneNo: "" } });
    }
    if (isEmpty(value)) {
      setErrors({ ...errors, ...{ phoneNo: "" } });
    }
    if (dialCode) {
      formData = {
        ...formData,
        ...{
          phoneCode: dialCode,
          phoneNo: phoneNo.slice(dialCode.length),
        },
      };
    } else if (value) {
      formData = { ...formData, ...{ phoneNo } };
    }
    setFormValue(formData);
  };

  const handlePassIcon = (name) =>
    setFormValue({ ...formValue, ...{ [name]: !formValue[name] } });

  const handleSubmit = async (e) => {
    try {
      if (!isEmpty(phoneCode) || !isEmpty(phoneCode)) {
        if (!isValidPhoneNumber("+" + phoneCode + phoneNo)) {
          setErrors({ ...errors, ...{ phoneNo: t("PHONE_NUMBER_INVALID") } });
          return;
        }
      }
      setLoader(true);
      const { status, loading, message, error } = await createUser(formValue);
      setLoader(loading);
      if (status == "success") {
        setFormValue(initialFormValue);
        toastAlert("success", t(message), "signup", "TOP_CENTER");
        navigate("/login");
      } else if (status === "OTP") {
        setFormValue({ ...formValue, ...{ otpStatus: true } });
        setErrors({});
        setTimerDetail({
          ...timerDetail,
          ...{
            isLoading: false,
            isDisable: true,
            timer: timerDetail.timer - 1,
            timerStart: true,
          },
        });
        toastAlert("success", t(message), "signup", "TOP_CENTER");
        localStorage.removeItem("refCode");
      } else {
        if (error) {
          setErrors(error);
          return false;
        }
        toastAlert("error", t(message), "signup", "TOP_CENTER");
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  const handleresendotp = async (e) => {
    try {
      setTimerDetail({
        ...timerDetail,
        ...{ isLoading: true, isDisable: true },
      });
      let req = { ...formValue, ...{ otpStatus: false } };
      setLoader(true);
      const { status, loading, message, error } = await createUser(req);
      setLoader(loading);
      if (status == "success") {
        setFormValue(initialFormValue);
        toastAlert("success", t(message), "signup", "TOP_CENTER");
        navigate("/login");
      } else if (status === "OTP") {
        setFormValue({ ...formValue, ...{ otpStatus: true } });
        setErrors({});
        setTimerDetail({
          ...timerDetail,
          ...{
            isLoading: false,
            isDisable: true,
            timer: timerDetail.timer - 1,
            timerStart: true,
            type: "resend",
          },
        });
        toastAlert("success", t(message), "signup", "TOP_CENTER");
        localStorage.removeItem("refCode");
      } else {
        setTimerDetail({
          ...timerDetail,
          ...{ isLoading: false, isDisable: false },
        });
        if (error) {
          setErrors(error);
          return false;
        }
        toastAlert("error", t(message), "signup", "TOP_CENTER");
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  useEffect(() => {
    if (timerDetail.timer > 0 && timerDetail.timerStart === true) {
      const intervalId = setInterval(() => {
        setTimerDetail({
          ...timerDetail,
          ...{ timer: timerDetail.timer - 1 },
        });
      }, 2000);

      return () => clearInterval(intervalId);
    } else if (timerDetail.timer === 0 && timerDetail.timerStart === true) {
      setTimerDetail({
        ...timerDetail,
        ...{
          timer: 120,
          timerStart: false,
          isDisable: false,
        },
      });
    }
  }, [timerDetail]);

  useEffect(() => {
    if (!isEmpty(refCode)) {
      // Example usage:
      const key = "refCode";
      const value = refCode;
      const expirationMinutes = 10;
      setLocalStorageWithExpiration(key, value, expirationMinutes);
      navigate("/register");
    }
  }, [refCode]);

  useEffect(() => {
    const retrievedValue = getLocalStorageWithExpiration("refCode");
    if (!isEmpty(retrievedValue)) {
      setFormValue({
        ...formValue,
        ...{ ["referralCode"]: retrievedValue, ["referralCodeDisabled"]: true },
      });
    }
  }, []);

  return (
    <>
      <div className="login_page_wrapper">
        <div className="login_split_container">
          {/* Left Side - Image (50%) */}
          <div className="login_image_half d-none d-lg-flex">
            <img
              src={require("../../assets/images/home/auth_bg.png")}
              alt="Professional Meeting"
              className="login_image_full"
            />
          </div>

          {/* Right Side - Form (50%) */}
          <div className="login_form_half">
            <div className="login_form_wrapper">
              {/* Logo Section */}
              <div className="login_logo_section">
                <Link className="" to="/">
                  <img
                    src={logo}
                    className="img-fluid brand_logo"
                    alt="Light logo"
                  />
                </Link>
              </div>

              {/* Register Title */}
              <h2 className="login_form_title">{t("REGISTER")}</h2>

              {/* Form */}
              <form className="login_form_fields">
                {/* First Name & Last Name */}
                <div style={{ display: "flex", gap: "10px" }}>
                  <div className="form_field_group" style={{ flex: 1 }}>
                    <label htmlFor="firstName" className="form_field_label">
                      {t("FIRST_NAME")}
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      className="form_field_input"
                      placeholder={t("FIRST_NAME_PLACEHOLDER")}
                      name="firstName"
                      onChange={handleChange}
                      value={firstName}
                    />
                    <span className="form_field_error">
                      {t(errors?.firstName)}
                    </span>
                  </div>
                  <div className="form_field_group" style={{ flex: 1 }}>
                    <label htmlFor="lastName" className="form_field_label">
                      {t("LAST_NAME")}
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      className="form_field_input"
                      placeholder={t("LAST_NAME_PLACEHOLDER")}
                      name="lastName"
                      onChange={handleChange}
                      value={lastName}
                    />
                    <span className="form_field_error">
                      {t(errors?.lastName)}
                    </span>
                  </div>
                </div>

                {/* Email Field */}
                <div className="form_field_group">
                  <label htmlFor="email" className="form_field_label">
                    {t("EMAIL")}
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form_field_input"
                    placeholder={t("EMAIL_PLACEHOLDER")}
                    name="email"
                    onChange={handleChange}
                    value={email}
                  />
                  <span className="form_field_error">{t(errors?.email)}</span>
                </div>

                {/* Phone Number */}
                <div className="form_field_group">
                  <label htmlFor="phone" className="form_field_label">
                    {t("PHONE_NUMBER")}
                  </label>
                  <PhoneInput
                    placeholder={t("PHONE_PLACEHOLDER")}
                    value={phoneCode + phoneNo}
                    onChange={handlePhoneNumber}
                    specialLabel={false}
                    enableSearch={true}
                    country={'us'}
                    // inputStyle={{
                    //   width: "100%",
                    //   padding: "12px 15px",
                    //   border: "1px solid #f4f3f3",
                    //   borderRadius: "4px",
                    //   fontSize: "14px",
                    //   background: "#f4f3f3",
                    // }}
                  />
                  <span className="form_field_error">
                    {errors && t(errors.phoneNo)}
                  </span>
                </div>

                {/* Password Field */}
                <div className="form_field_group">
                  <label htmlFor="password" className="form_field_label">
                    {t("PASSWORD")}
                  </label>
                  <div className="password_field_wrapper">
                    <input
                      type={!passwordIcon ? "password" : "text"}
                      id="password"
                      className="form_field_input"
                      placeholder={t("PASSWORD_PLACEHOLDER")}
                      name="password"
                      onChange={handleChange}
                      value={password}
                    />
                    <span
                      className="password_icon_toggle"
                      onClick={() => handlePassIcon("passwordIcon")}
                    >
                      <i
                        className={
                          passwordIcon
                            ? "bi bi-eye-fill"
                            : "bi bi-eye-slash-fill"
                        }
                      ></i>
                    </span>
                  </div>
                  <span className="form_field_error">
                    {t(errors?.password)}
                  </span>
                </div>

                {/* Confirm Password Field */}
                <div className="form_field_group">
                  <label htmlFor="confirmPassword" className="form_field_label">
                    {t("CONFIRM_PASSWORD")}
                  </label>
                  <div className="password_field_wrapper">
                    <input
                      type={!confirmPasswordIcon ? "password" : "text"}
                      id="confirmPassword"
                      className="form_field_input"
                      placeholder={t("CONFIRM_PASSWORD_PLACEHOLDER")}
                      name="confirmPassword"
                      onChange={handleChange}
                      value={confirmPassword}
                    />
                    <span
                      className="password_icon_toggle"
                      onClick={() => handlePassIcon("confirmPasswordIcon")}
                    >
                      <i
                        className={
                          confirmPasswordIcon
                            ? "bi bi-eye-fill"
                            : "bi bi-eye-slash-fill"
                        }
                      ></i>
                    </span>
                  </div>
                  <span className="form_field_error">
                    {t(errors?.confirmPassword)}
                  </span>
                </div>

                {/* OTP Field - Show only after OTP status is true */}
                {otpStatus == true && (
                  <div className="form_field_group">
                    <label htmlFor="otp" className="form_field_label">
                      {t("OTP")}
                    </label>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="text"
                        id="otp"
                        className="form_field_input"
                        style={{ flex: 1 }}
                        placeholder={t("OTP_PLACEHOLDER")}
                        name="otp"
                        onChange={handleChange}
                        value={otp}
                      />
                      {timerDetail.timer !== 0 && timerDetail.timer !== 120 ? (
                        <span
                          className="form_field_label"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {`${timerDetail.timer} ${t("SEC")}`}
                        </span>
                      ) : (
                        <button
                          type="button"
                          onClick={(e) =>
                            !timerDetail.isDisable && handleresendotp(e)
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: "#4a7c5a",
                            cursor: timerDetail.isDisable
                              ? "not-allowed"
                              : "pointer",
                            whiteSpace: "nowrap",
                            textDecoration: "underline",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                          disabled={timerDetail.isDisable}
                        >
                          {t("RESENT_OTP")}
                        </button>
                      )}
                    </div>
                    <span className="form_field_error">{t(errors?.otp)}</span>
                  </div>
                )}

                {/* Terms & Conditions Checkbox */}
                <div
                  className="form_checkbox_wrapper"
                  style={{ marginTop: "15px", marginBottom: "15px" }}
                >
                  <input
                    type="checkbox"
                    id="terms"
                    className="form_checkbox_input"
                    name="isTerms"
                    onChange={handleChange}
                    checked={isTerms}
                  />
                  <label htmlFor="terms" className="form_checkbox_label">
                    <Trans
                      i18nKey="REGISTER_CHECKBOX"
                      components={{
                        Link: (
                          <Link
                            to="/terms"
                            style={{
                              color: "#4a7c5a",
                              textDecoration: "underline",
                            }}
                          ></Link>
                        ),
                        Link1: (
                          <Link
                            to="/privacy"
                            style={{
                              color: "#4a7c5a",
                              textDecoration: "underline",
                            }}
                          ></Link>
                        ),
                      }}
                      values={{
                        value1: "Terms of Use",
                        value2: "Privacy Policy",
                      }}
                    />
                  </label>
                </div>
                {errors?.isTerms && (
                  <span className="form_field_error">{t(errors?.isTerms)}</span>
                )}

                {/* Register Button */}
                <button
                  type="button"
                  className="primary_btn"
                  onClick={handleSubmit}
                  disabled={loader}                  
                >
                  {loader && <i className="fas fa-spinner fa-spin"></i>}
                  <span>{t("REGISTER")}</span>
                </button>
              </form>

              {/* Sign In Link */}
              <p className="form_signup_text">
                {t("ALREADY_HAVE_ACCOUNT")}?{" "}
                <Link to="/login" className="form_signup_link">
                  {t("SIGN_IN")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterForm;
